import axios, { AxiosResponse } from 'axios';
import BaseService from './baseService';

interface LoginData {
  [key: string]: any;
}

interface LoginResponse {
  acesso: {
    access_token: string;
    refresh_token: string;
  };
}

interface Membro {
  [key: string]: any;
}

interface Trilha {
  licoes: any[];
  [key: string]: any;
}

interface ActiveUserResponse {
  trilhas: Trilha[];
  licoes?: number;
  [key: string]: any;
}

interface RefreshTokenRequest {
  token: string;
}

interface RefreshTokenResponse {
  acesso: {
    access_token: string;
    refresh_token: string;
  };
}

interface BnData {
  access_token: string;
  refresh_token: string;
  [key: string]: any;
}

class LoginService extends BaseService {

  async login(data: LoginData): Promise<{ acesso: BnData }> {
    try {
      const response: AxiosResponse<LoginResponse> = await axios.post(
        `${this.getApiUrl()}/auth/signin`, 
        data
      );
      const { acesso } = response.data;
      localStorage.setItem('bn', btoa(JSON.stringify(acesso)));
      return { acesso };
    } catch (error) {
      throw error;
    }
  }

  async loggedUser(): Promise<Membro> {
    try {
      const response: AxiosResponse<{ membro: Membro }> = await axios.get(
        `${this.getApiUrl()}/membro-logado`
      );
      return response.data.membro;
    } catch (error) {
      throw error;
    }
  }

  async activeUser(): Promise<ActiveUserResponse | boolean> {
    const bnString = localStorage.getItem('bn');
    if (!bnString) {
      return false;
    }

    try {
      const bn: BnData = JSON.parse(atob(bnString));
      if (!bn.access_token) {
        return false;
      }

      const response: AxiosResponse<ActiveUserResponse> = await axios.get(
        `${this.getApiUrl()}/login-ativo`
      );
      const result: ActiveUserResponse = response.data;
      
      // Calculate total lessons
      let licoes = 0;
      for (let i = 0; i < result.trilhas.length; i++) {
        licoes = licoes + result.trilhas[i].licoes.length;
      }
      result.licoes = licoes;

      return result;
    } catch (error) {
      const bn: BnData = JSON.parse(atob(bnString || '{}'));
      if (bn.refresh_token) {
        try {
          const refreshResponse: AxiosResponse<RefreshTokenResponse> = await axios.post(
            `${this.getApiUrl()}/refresh-token`, 
            {
              token: bn.refresh_token,
            } as RefreshTokenRequest
          );
          localStorage.setItem('bn', btoa(JSON.stringify(refreshResponse.data.acesso)));
          window.location.reload();
          return true;
        } catch (refreshError) {
          this.loggout();
          throw refreshError;
        }
      }
      this.loggout();
      throw error;
    }
  }

  getToken(): string | null {
    try {
      const bn: BnData = JSON.parse(atob(localStorage.getItem('bn') || '{}'));
      return bn.access_token;
    } catch (error) {
      return null;
    }
  }

  isLoggedIn(): boolean {
    const bnString = localStorage.getItem('bn');
    if (!bnString) {
      return false;
    }
    try {
      const bn: BnData = JSON.parse(atob(bnString));
      return !!bn.access_token;
    } catch (error) {
      return false;
    }
  }

  checkLogged(): BnData | null {
    try {
      const bn: BnData = JSON.parse(atob(localStorage.getItem('bn') || '{}'));
      if (!bn.access_token) {
        return null;
      }
      return bn;
    } catch (error) {
      return null;
    }
  }

  loggout(): void {
    localStorage.removeItem('bn');
    window.location.href = '/';
  }
}

export const loginService = new LoginService(); 